import React from 'react';
import { Modal } from '@zambezi/sdk/modal';
var ConfirmCountdownModal = function ConfirmCountdownModal(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    open = _ref.open,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    time = _ref.time;
  return /*#__PURE__*/React.createElement(Modal, {
    className: "".concat(className, " ob-modal js-modal"),
    title: "Session expiry",
    withBackdrop: true,
    open: open,
    isClosable: false,
    onCancel: onCancel,
    onConfirm: onConfirm,
    renderFooter: function renderFooter(onConfirm, onCancel) {
      return /*#__PURE__*/React.createElement("div", {
        className: "zb-modal-card-foot-actions"
      }, /*#__PURE__*/React.createElement("button", {
        className: "js-confirm-action zb-button zb-button-primary zb-modal-action",
        onClick: onConfirm
      }, "Continue with my session"), /*#__PURE__*/React.createElement("button", {
        className: "zb-button-link zb-modal-action js-cancel-action",
        onClick: onCancel
      }, "Logout"));
    }
  }, "Your session will expire in ", time, " seconds. Do you wish to continue?");
};
export default ConfirmCountdownModal;